import { ScrollShadow } from '@heroui/scroll-shadow';
import ModalFood from './modalFood';

import { useDisclosure } from '@heroui/react';

type productType ={
  title: string,
  description: string,
  photo: string
}

export type ProductCardProps = {
  title: string;
  health: string;
  listProducts: productType[];
  image: string;
  /** Color de fondo de la tarjeta (ej. "#DEBE95" o "rgb(222,190,149)") */
  bgColor: string;
  route?: string;
};

export default function ProductCard({
  title,
  listProducts,
  image,
  bgColor = "#fff",
  health
}: ProductCardProps) {

  const { isOpen, onOpen, onOpenChange } = useDisclosure()


  return (
    <div
      className="w-[260px] sm:w-[300px] rounded-xl shadow-md p-5 flex flex-col h-[450px] transform transition-transform duration-300 hover:scale-105 hover:cursor-pointer place-self-center"
      style={{ backgroundColor: bgColor }}
      onClick={(e) => {
        if (isOpen) {
          e.stopPropagation();
          return;
        }
        onOpen();
      }}
    >

      {/* Título */}
      <h2 className="italic text-white/95 leading-tight mb-2 font-light">
        {title}
      </h2>

      {/* Lista (scrollable si crece) */}

      <ScrollShadow
        hideScrollBar
        className={listProducts.length > 4 ? "max-h-28" : ""}
      >
        <ul className="text-white/90 text-2xl leading-7 pl-4">
          {listProducts.map((item, i) => (
            <li key={i} className="whitespace-nowrap">
              {item.title}
            </li>
          ))}
        </ul>
      </ScrollShadow>


      {/* Imagen centrada */}
      <div className="mt-4 flex-1 flex items-center justify-center h-full ">
        <img
          src={image}
          alt={title}
          className="block max-h-40 object-contain"
        />
      </div>

      <ModalFood
        food={{
          title,
          listProducts,
          image,
          bgColor,
          health,
        }}
        isOpen={isOpen}
        onOpenChange={onOpenChange}
      />
    </div>
  );
}
